import * as React from 'react'

const SilverMedal = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    ref={ref}
    {...props}
  >
    <path
      d="M18.768 11.51L13.548 2.93C13.208 2.35 12.598 2 11.928 2H5.33801C3.88801 2 2.97801 3.56 3.68801 4.82C5.00765 7.15472 6.87016 9.13729 9.11801 10.6C9.87801 11.19 10.818 11.51 11.788 11.51H18.768Z"
      fill="#0074BA"
    />
    <path
      d="M26.658 2H20.068C19.398 2 18.788 2.35 18.448 2.93L13.228 11.51H20.218C21.188 11.51 22.118 11.19 22.888 10.6C25.138 9.14 26.998 7.16 28.318 4.82C29.018 3.56 28.108 2 26.658 2Z"
      fill="#00A6ED"
    />
    <path
      d="M15.96 30.001C21.505 30.001 26 25.394 26 19.711C26 14.028 21.505 9.421 15.96 9.421C10.415 9.421 5.92001 14.028 5.92001 19.711C5.92001 25.394 10.415 30.001 15.96 30.001Z"
      fill="#BEBEBE"
    />
    <path
      d="M15.96 28.761C13.6 28.761 11.38 27.821 9.72001 26.111C8.04949 24.4007 7.11912 22.1017 7.13001 19.711C7.13001 17.291 8.05001 15.021 9.72001 13.311C10.5303 12.4736 11.5007 11.8077 12.5736 11.353C13.6464 10.8982 14.7998 10.6639 15.965 10.6639C17.1303 10.6639 18.2836 10.8982 19.3564 11.353C20.4293 11.8077 21.3997 12.4736 22.21 13.311C25.65 16.841 25.65 22.581 22.21 26.111C20.53 27.821 18.31 28.761 15.96 28.761ZM15.95 11.891C14 11.891 12.04 12.651 10.56 14.181C9.12012 15.6605 8.31924 17.6465 8.33001 19.711C8.33001 21.801 9.12001 23.761 10.56 25.241C11.2582 25.9656 12.0954 26.5419 13.0216 26.9354C13.9477 27.3289 14.9437 27.5315 15.95 27.531C17.99 27.531 19.9 26.721 21.34 25.241C24.31 22.191 24.31 17.231 21.34 14.181C20.6425 13.4554 19.8054 12.8785 18.8791 12.485C17.9528 12.0914 16.9564 11.8894 15.95 11.891Z"
      fill="#E6E6E6"
    />
    <path
      d="M17.838 23.95H13.868C13.6768 23.9505 13.4894 23.8961 13.3281 23.7933C13.1668 23.6905 13.0384 23.5436 12.958 23.37C12.8752 23.1979 12.8435 23.0056 12.8665 22.816C12.8896 22.6264 12.9664 22.4473 13.088 22.3L16.388 18.25C16.648 17.93 16.528 17.59 16.488 17.49C16.4411 17.3739 16.3611 17.2741 16.258 17.203C16.1549 17.1319 16.0332 17.0926 15.908 17.09H15.858C15.538 17.09 15.248 17.24 15.058 17.5C14.738 17.95 14.108 18.06 13.648 17.74C13.5395 17.6633 13.4473 17.5659 13.3765 17.4535C13.3057 17.3411 13.2577 17.2158 13.2354 17.0848C13.2132 16.9538 13.2169 16.8197 13.2465 16.6902C13.2761 16.5607 13.331 16.4383 13.408 16.33C13.968 15.54 14.878 15.07 15.848 15.07H15.978C16.998 15.12 17.888 15.73 18.308 16.66C18.738 17.62 18.598 18.71 17.938 19.52L15.988 21.92H17.828C18.388 21.92 18.838 22.37 18.838 22.93C18.838 23.49 18.398 23.95 17.838 23.95Z"
      fill="#636363"
    />
  </svg>
))

SilverMedal.displayName = 'SilverMedal'

export { SilverMedal }
